<template>
  <div>
    <page-title>Survey Categories</page-title>

    <loading v-if="loading" />

    <main v-else>
      <section-block>
        <template slot="header">
          <filter-bar
            resource="FormCategories"
            :search-query="searchQuery"
            show-search
            :filter-options="categories"
          ></filter-bar>
        </template>

        <template slot="actions" v-if="$route.meta.isAdmin">
          <base-button
            :primary="true"
            @click="$router.push({name: 'AdminSurveyCategoriesCreatePage'})"
            iconBefore="document-create"
            v-if="userCanAdd"
          >
            <span>Add a category</span>
          </base-button>
        </template>
        <base-empty v-if="!categories || categories.length < 1">
          <p>
            There are no categories yet.
            <br />Why not
            <router-link :to="{name:'AdminSurveyCategoriesCreatePage'}">create one now</router-link>?
          </p>
        </base-empty>
        <vuetable
          v-else
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data="categories"
          @vuetable:row-clicked="onRowClicked"
        >
          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>
          <template slot="parent" slot-scope="props">
            <router-link
              v-if="props.rowData.parent_id"
              :to="{name:'AdminSurveyCategoriesEditPage',params:{id:props.rowData.parent_id}}"
            >{{ props.rowData.parent_data.name}}</router-link>
            <span v-else>(Not set)</span>
          </template>

          <template slot="category-actions" slot-scope="props">
            <category-actions
              routePath="AdminSurveyCategoriesEditPage"
              :id="props.rowData.id"
              deleteAction="SurveyCategories/delete"
              :can-delete="userCanAdd"
            ></category-actions>
          </template>
        </vuetable>
      </section-block>
    </main>
  </div>
</template>

<script>
const BaseEmpty = () => import("@/components/elements/BaseEmpty");
const CategoryActions = () => import("@/components/CategoryActions");

import { mapState } from "vuex";
import UserHasPermission from "@/mixins/UserHasPermission";

export default {
  name: "AdminSurveyCategoriesIndexPage",
  components: {
    BaseEmpty,
    CategoryActions
  },
  mixins: [UserHasPermission],
  props: {},
  data() {
    return {
      loading: true,
      searchQuery: "",
      table: {
        fields: [
          {
            name: "name",
            titleClass: "u-ta-left",
            title: "Category Name",
            width: "40%"
          },
          {
            name: "parent",
            titleClass: "u-ta-left",
            title: "Category parent",
            width: "20%"
          },
          {
            name: "date-created",
            titleClass: "u-ta-left",
            title: "Date Created",
            width: "20%"
          },
          {
            name: "category-actions",
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "10%"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("SurveyCategories", ["categories"]),
    userCanAdd() {
      return this.userHasPermission("add_survey_categories");
    },
  },
  watch: {},
  beforeCreate() {},
  async created() {
    if (!this.userCanAdd) {
      this.table.fields = this.table.fields.slice(0,-1);
    }
    await this.$store.dispatch("SurveyCategories/list");
    this.loading = false;
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  methods: {
    onRowClicked() {}
  }
};
</script>

<style lang="scss" scoped>
td > td {
  border: none;
  padding: 0;
  display: inline-block;
}
</style>